import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import LandingNav from './components/LandingNav';
import QuickQuoteWidget from './components/QuickQuoteWidget';
import FloatingCTA from './components/FloatingCTA';
import Hero from './sections/Hero';
import Servizi from './sections/Servizi';
import ChiSiamo from './sections/ChiSiamo';
import Galleria from './sections/Galleria';
import AreaOperativa from './sections/AreaOperativa';
import FAQ from './sections/FAQ';
import Contatti from './sections/Contatti';
import Footer from './sections/Footer';
import { COMPANY, jsonLdLocalBusiness, jsonLdFAQ, jsonLdBreadcrumb, jsonLdServicesItemList } from './seo';
import { LandingContentProvider } from './useLandingContent';

// Global context to open the QuickQuote modal from anywhere in the landing
export const QuickQuoteContext = React.createContext(() => {});

export default function LandingPage() {
  const [qqOpen, setQqOpen] = useState(false);
  const openQuickQuote = () => setQqOpen(true);
  return (
    <div className="bg-stone-50 text-stone-900 antialiased" data-testid="landing-page">
      <Helmet>
        <html lang="it-IT" />
        <title>EDIL CIMA S.R.L. — Impresa Edile a Calcinato (BS) | Ristrutturazioni, Tetti, Piscine</title>
        <meta name="description" content="EDIL CIMA S.R.L. — impresa edile a Calcinato (Brescia) dal 2000. Nuove costruzioni, ristrutturazioni complete, rifacimento tetti, piscine e manutenzioni. Preventivi gratuiti, lavori certificati. Tel. 030 9985813." />
        <meta name="keywords" content="impresa edile Brescia, ristrutturazioni Calcinato, costruzioni edili Brescia, rifacimento tetti BS, realizzazione piscine Brescia, manutenzioni condomini, edile Calcinato, Edil Cima, Cima Germano" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta name="author" content="EDIL CIMA S.R.L." />
        <meta name="geo.region" content="IT-BS" />
        <meta name="geo.placename" content="Calcinato, Brescia, Lombardia" />
        <meta name="geo.position" content="45.4543;10.4117" />
        <meta name="ICBM" content="45.4543, 10.4117" />
        <link rel="canonical" href="https://edilcima.it/" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="it_IT" />
        <meta property="og:site_name" content="EDIL CIMA S.R.L." />
        <meta property="og:title" content="EDIL CIMA S.R.L. — Impresa Edile a Calcinato (Brescia)" />
        <meta property="og:description" content="Da oltre 20 anni costruiamo, ristrutturiamo e manuteniamo case, tetti e piscine in provincia di Brescia. Preventivi gratuiti." />
        <meta property="og:url" content="https://edilcima.it/" />
        <meta property="og:image" content="https://impresaedilecima.it/wp-content/uploads/2023/10/IMG_4196.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="EDIL CIMA S.R.L. — Impresa Edile a Calcinato (BS)" />
        <meta name="twitter:description" content="Impresa edile a Calcinato (Brescia). Costruzioni, ristrutturazioni, tetti, piscine, manutenzioni dal 2000." />
        <meta name="twitter:image" content="https://impresaedilecima.it/wp-content/uploads/2023/10/IMG_4196.jpg" />
        <meta name="theme-color" content="#0a0a0a" />
        <script type="application/ld+json">{JSON.stringify(jsonLdLocalBusiness)}</script>
        <script type="application/ld+json">{JSON.stringify(jsonLdFAQ)}</script>
        <script type="application/ld+json">{JSON.stringify(jsonLdBreadcrumb)}</script>
        <script type="application/ld+json">{JSON.stringify(jsonLdServicesItemList)}</script>
      </Helmet>

      <QuickQuoteContext.Provider value={openQuickQuote}>
        <LandingContentProvider>
          <LandingNav />
          <main>
            <Hero />
            <Servizi />
            <ChiSiamo />
            <Galleria />
            <AreaOperativa />
            <FAQ />
            <Contatti />
          </main>
          <Footer />
          <FloatingCTA />
          <QuickQuoteWidget open={qqOpen} onClose={() => setQqOpen(false)} />
        </LandingContentProvider>
      </QuickQuoteContext.Provider>
    </div>
  );
}
